import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  getFilteredParametersValuesNotEmpty, getFilteredParameterValuesNotEmpty
} from 'store/dataset';

import BoxPlot from 'components/BoxPlot';
import { getBoxPlotData } from 'calculators/graphicalStatistics/boxPlot';

const BoxPlotContainer = props =>
  <BoxPlot
    boxes={getBoxPlotData(props.firstParsedParameterValues, props.categoricalParameter ? props.secondParsedParameterValues : null)}
    yAxisLabel={props.numericalParameter}
    xAxisLabel={props.categoricalParameter}
  />;


BoxPlotContainer.propTypes = {
  numericalParameter: PropTypes.string.isRequired,
  categoricalParameter: PropTypes.string,

  firstParsedParameterValues: PropTypes.arrayOf(
    PropTypes.number.isRequired
  ).isRequired,

  secondParsedParameterValues: PropTypes.array
};

const mapStateToProps = (state, props) => {

  let filteredValues = {
    firstParsedParameterValues: null,
    secondParsedParameterValues: null
  };

  if (!props.categoricalParameter) {
    filteredValues.firstParsedParameterValues = getFilteredParameterValuesNotEmpty(state, props.numericalParameter);
  } else {
    filteredValues = getFilteredParametersValuesNotEmpty(
      state,
      props.numericalParameter,
      props.categoricalParameter
    );
  }

  return ({
    ...filteredValues
  });
};

export default connect(mapStateToProps)(BoxPlotContainer);
